import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link, Outlet } from "react-router-dom";
import { TextField } from "@mui/material";
import TextareaAutosize from "@mui/material/TextareaAutosize/index";
import Button from "@mui/material/Button/Button";
import { HashLink } from "react-router-hash-link";
export class Home extends Component {
  static propTypes = {};

  render() {
    return (
      <div>
        <section className="main">
          <div className="container">
            <div className="wrap">
              <div className="profile-images">
                <img
                  src="https://avatars.githubusercontent.com/u/87593477?v=4"
                  alt=""
                />
              </div>
              <div className="name">
                <h1>Biki karmakar</h1>
                <h2>Software Engineer</h2>
              </div>
              <div className="social-link">
                <ul>
                  <li>
                    <Link to="">
                      {" "}
                      <i className="fa fa-twitter"></i>
                    </Link>
                  </li>
                  <li>
                    <Link to="">
                      <i className="fa fa-facebook"></i>
                    </Link>
                  </li>
                  <li>
                    <Link to="">
                      <i className="fa fa-instagram"></i>
                    </Link>
                  </li>
                  <li>
                    <Link to="">
                      <i className="fa fa-linkedin"></i>
                    </Link>
                  </li>
                </ul>
              </div>
              <HashLink className="hire" smooth to="/#here">
                Hire Me
              </HashLink>
            </div>
          </div>
        </section>

        <section className="about py-5">
          <div className="container">
            <div className="about-info">
              <div className="heading text-center"></div>

              <div className="box-info">
                <div className="profile-info">
                  <img
                    src="https://avatars.githubusercontent.com/u/87593477?v=4"
                    alt=""
                  />
                </div>
                <div className="info">
                  <h1>About Me</h1>
                  <p className="text-start">
                    Hi There, <br />
                    i'm Biki karmakar , I am belong to West Bengal, I have
                    completed my gradution in BCA from Moulana abul kalam azad
                    university and Technology year 2020, i have it experince
                    Aroud 2 yr, i am avalibel on Freelancer, working on
                    hiringhippo lest 1yr,
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="projects">
          <div className="container">
            <h1>Projects</h1>
            <ul>
              <li>
                <Link to="all">All </Link>
              </li>

              <li>
                <Link to="live">Live </Link>
              </li>
              <li>
                <Link to="demo">Demo</Link>
              </li>
            </ul>

            <Outlet />
          </div>
        </section>

        <section className="contact" id="here">
          <div className="container">
            <h1 className="text-center">Contact Me</h1>
            <div className="contact-info">
              <div className="social-info">
                <ul>
                  <li>
                    <i class="fa fa-envelope" aria-hidden="true"></i>
                    <strong>E-mail :</strong> bikikarmakar19@gmail.com
                  </li>
                  <li>
                    <i className="fa fa-github"></i> <strong>Github :</strong>{" "}
                    https://github.com/19Kbiki
                  </li>
                  <li>
                    <i className="fa fa-linkedin"></i>{" "}
                    <strong>Linkedin :</strong>{" "}
                    https://www.linkedin.com/in/bikikarmakar/
                  </li>
                  <li>
                    <i className="fa fa-phone"></i> <strong>Phone :</strong>{" "}
                    +91-6294-667-292
                  </li>
                </ul>
              </div>

              <form>
                <div className="wrap">
                  <TextField
                    required
                    id="outlined-basic"
                    label="Name"
                    variant="outlined"
                  />
                  <TextField
                    required
                    id="outlined-basic"
                    label="E-mail"
                    variant="outlined"
                  />
                  <TextField
                    required
                    id="outlined-basic"
                    label="Mobile No."
                    variant="outlined"
                  />
                  <TextareaAutosize
                    aria-label="empty textarea"
                    minRows={4}
                    placeholder="Message"
                    id="textarea"
                  />
                  <Button variant="contained">Hire me</Button>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Home;
